import script from "./NotificationBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationBar.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationBar.vue?vue&type=style&index=0&id=91c90c76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91c90c76"]])

export default __exports__